import React, { Component } from "react";
import { connect } from "react-redux";
import Incidents from "./Incidents";
import _ from "lodash";

class IncidentsPage extends Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {}

  render() {
    if (this.props.customerInformation.plusCustomer != null) {
      return <Incidents {...this.props} />;
    }

    return (
      <div className="my-nodes-page">
        <section className="main-content">
          <div className="container" />
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    customerInformation: state.customerInformation,
    errors: state.errors
  };
}

export default connect(mapStateToProps)(IncidentsPage);



// WEBPACK FOOTER //
// ./src/incidents/IncidentsPage.js